/* ==========================================================================
   Website forms → Staff Portal CRM leads.
   1. Every Shopify contact form (contact, appointment, back-in-stock, savings
      plan…) still goes to the store email as before; a copy is also sent to
      the Cloudflare Worker, which adds it as a lead (or a note on the existing
      lead with the same mobile / email).
   2. The enquiry page (sections/enquiry-form.liquid, the Instagram bio link)
      posts only to the Worker and shows a thank-you + WhatsApp button.
   The source (?src=instagram / utm_source) is remembered for the visit.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__stjCapture) return;
  window.__stjCapture = true;

  var script = document.currentScript;
  var URL_BASE = ((script && script.getAttribute('data-url')) || '').replace(/\/+$/, '');
  var CAPTURE_CONTACT = !script || script.getAttribute('data-contact') !== 'false';
  if (!URL_BASE) return;

  // remember where the visitor came from
  var params = new URLSearchParams(location.search);
  var src = params.get('src') || params.get('utm_source') || '';
  try {
    if (src) sessionStorage.setItem('stj_src', src);
    else src = sessionStorage.getItem('stj_src') || '';
  } catch (e) {}

  function send(data, keepalive) {
    data.src = data.src || src;
    data.page = data.page || location.pathname;
    // text/plain = no CORS pre-flight, so the request survives the page reload
    return fetch(URL_BASE + '/public/lead', { method: 'POST', body: JSON.stringify(data), keepalive: !!keepalive, headers: { 'Content-Type': 'text/plain' } });
  }

  /* ---------- 1. Shopify contact forms ---------- */
  var CORE = { name: 'name', phone: 'mobile', mobile: 'mobile', email: 'email', body: 'message', product: 'product' };
  var SKIP = /^(form|tags|reference number|link|variant|plan number|plan completes|plan value)$/i;
  function formLabel(f) {
    var el = f.querySelector('[name="contact[form]"], [name="contact[Form]"]');
    if (el && el.value) return el.value;
    if (f.id === 'AppointmentForm') return 'Appointment';
    return 'Contact form';
  }
  function readContactForm(f) {
    var data = { form: formLabel(f), extra: {} };
    Array.prototype.forEach.call(f.elements, function (el) {
      var m = /^contact\[(.+)\]$/.exec(el.name || '');
      if (!m || el.disabled || ((el.type === 'checkbox' || el.type === 'radio') && !el.checked)) return;
      var key = m[1], val = String(el.value || '').trim();
      if (!val) return;
      var core = CORE[key.toLowerCase()];
      if (core) { data[core] = val; return; }
      if (SKIP.test(key)) return;
      var label = el.getAttribute('data-prop') || key.replace(/_/g, ' ').replace(/^\w/, function (c) { return c.toUpperCase(); });
      data.extra[label] = val;
    });
    var ref = f.querySelector('[data-booking-ref]');
    if (ref && ref.value) data.extra['Reference'] = ref.value;
    // appointment booking → also goes to the Appointments tab
    if (f.hasAttribute('data-booking-form') || f.id === 'AppointmentForm') {
      var val = function (n) { var el = f.querySelector('[name="contact[' + n + ']"]'); return el && !el.disabled ? String(el.value || '').trim() : ''; };
      var details = [['Number of people', 'piercing_people'], ['Age', 'piercing_age'], ['Piercing type', 'piercing_type'], ['Piercing at', 'piercing_location'], ['Pincode', 'pincode']]
        .map(function (x) { var v = val(x[1]); return v ? x[0] + ': ' + v : ''; }).filter(Boolean);
      if (data.message) details.push('Message: ' + data.message);
      data.appointment = { type: val('type'), date: val('date'), time: val('time'), ref: ref ? ref.value : '', details: details.join('\n') };
    }
    return data;
  }
  var lastSent = {};
  function sendOnce(data) {
    if (!data.mobile && !data.email) return;
    var key = [data.form, data.mobile, data.email].join('|');
    if (lastSent[key] && Date.now() - lastSent[key] < 15000) return; // Shopify's spam check may submit twice
    lastSent[key] = Date.now();
    try { send(data, true).catch(function () {}); } catch (err) {}
  }
  // for forms handled by theme.js (spin the wheel …)
  window.stjCrmLead = function (data) { sendOnce(data || {}); };

  if (CAPTURE_CONTACT) {
    // Shopify's captcha can stop or delay the normal submit, so listen early (capture)
    // and send after the other submit handlers have filled their hidden fields.
    var pending = null;
    var isContact = function (f) {
      var type = f && f.tagName === 'FORM' && f.querySelector('input[name="form_type"]');
      return type && type.value === 'contact' && !f.hasAttribute('data-crm-skip') && !f.hasAttribute('data-spin-form');
    };
    document.addEventListener('submit', function (e) {
      if (!isContact(e.target)) return;
      var f = e.target;
      pending = f;
      setTimeout(function () { if (pending === f) { pending = null; sendOnce(readContactForm(f)); } }, 0);
    }, true);
    document.addEventListener('submit', function (e) {
      if (!isContact(e.target) || pending !== e.target) return;
      pending = null;
      sendOnce(readContactForm(e.target));
    });
  }

  /* ---------- 2. Enquiry page ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('form[data-crm-enquiry]'), function (f) {
    var box = f.closest('[data-enquiry]') || f.parentNode;
    var done = box.querySelector('[data-enquiry-done]');
    var err = f.querySelector('[data-enquiry-error]');
    var btn = f.querySelector('button[type="submit"]');
    var waNum = (f.getAttribute('data-whatsapp') || '').replace(/\D/g, '');
    var product = params.get('product') || '';
    if (product && f.elements.product) f.elements.product.value = product;
    // exhibition page: once filled, show the gift again on reload instead of the form
    var remember = box.getAttribute('data-enquiry-remember');
    // optional step between the form and the gift: "Follow us on Instagram"
    var follow = box.querySelector('[data-follow-step]');
    var store = function (k, v) { try { if (v) localStorage.setItem(k, v); return localStorage.getItem(k); } catch (e) { return null; } };
    var followed = function () { return !follow || !!store('stj_enq_' + (remember || 'form') + '_ig'); };
    var showDone = function () {
      f.hidden = true;
      if (!followed()) { follow.hidden = false; if (done) done.hidden = true; return follow; }
      if (follow) follow.hidden = true;
      if (done) done.hidden = false;
      return done;
    };
    if (follow) {
      var unlock = follow.querySelector('[data-follow-unlock]');
      var enable = function () { unlock.disabled = false; unlock.classList.remove('is-waiting'); };
      follow.querySelector('[data-follow-open]').addEventListener('click', function () {
        // give them a few seconds on Instagram, or enable as soon as they come back to this tab
        setTimeout(enable, 4000);
        document.addEventListener('visibilitychange', function () { if (!document.hidden) setTimeout(enable, 800); });
      });
      unlock.addEventListener('click', function () {
        store('stj_enq_' + (remember || 'form') + '_ig', '1');
        var el = showDone();
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    if (remember && store('stj_enq_' + remember)) showDone();

    function summary(d) {
      return ['Hi ' + (f.getAttribute('data-store') || '') + ', I filled the enquiry form.',
        'Name: ' + d.name, d.interest ? 'Looking for: ' + d.interest : '', d.budget ? 'Budget: ' + d.budget : '',
        d.occasion ? 'Occasion: ' + d.occasion : '', d.ring_size ? 'Ring size: ' + d.ring_size : '', d.product ? 'Product: ' + d.product : '',
        d.message ? 'Message: ' + d.message : ''].filter(Boolean).join('\n');
    }
    function waLink(d) { return waNum ? 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(summary(d)) : ''; }

    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (err) err.hidden = true;
      var el = f.elements;
      var d = {
        form: f.getAttribute('data-form-name') || 'Enquiry page',
        name: el.name.value.trim(), mobile: el.mobile.value.trim(), instagram: el.instagram ? el.instagram.value.trim() : '',
        city: el.city ? el.city.value.trim() : '', budget: el.budget ? el.budget.value : '', occasion: el.occasion ? el.occasion.value : '',
        ring_size: el.ring_size ? el.ring_size.value.trim() : '', message: el.message ? el.message.value.trim() : '',
        product: el.product ? el.product.value.trim() : '', consent: el.consent ? el.consent.checked : false, hp: el.website ? el.website.value : '',
        interest: Array.prototype.map.call(f.querySelectorAll('input[name="interest"]:checked'), function (i) { return i.value; }).join(', '),
        event: f.getAttribute('data-event') || '', visit: f.getAttribute('data-visit') === 'true',
      };
      if (f.getAttribute('data-src')) d.src = f.getAttribute('data-src');
      var digits = d.mobile.replace(/\D/g, '').slice(-10);
      if (!d.name || !/^[6-9]\d{9}$/.test(digits)) {
        if (err) { err.textContent = f.getAttribute('data-msg-invalid'); err.hidden = false; }
        return;
      }
      btn.disabled = true;
      var finish = function (ok) {
        btn.disabled = false;
        var wa = waLink(d);
        if (ok) {
          if (remember) store('stj_enq_' + remember, '1');
          var shown = showDone();
          var a = done && done.querySelector('[data-enquiry-wa]');
          if (a) { if (wa) a.href = wa; else a.hidden = true; }
          if (shown) shown.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (err) {
          err.innerHTML = '';
          err.appendChild(document.createTextNode(f.getAttribute('data-msg-error') + ' '));
          if (wa && f.getAttribute('data-msg-wa')) {
            var link = document.createElement('a');
            link.href = wa; link.target = '_blank'; link.rel = 'noopener'; link.textContent = f.getAttribute('data-msg-wa');
            err.appendChild(link);
          }
          err.hidden = false;
        }
      };
      send(d).then(function (r) { finish(r.ok); }).catch(function () { finish(false); });
    });
  });
})();
